import { useEffect, useState, useRef } from 'react';
import styled from 'styled-components'
import { GoogleLogin } from '@react-oauth/google';
import { getWecs } from './server';
import { authenticate, login, logout } from './server';
import Home from './Home';

const LoginContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Logo = styled.img`
  position: absolute;
  top: -1vh;
  left: -1vw;
  max-height: 30vh;
  max-width: 30vw;
`

const User = styled.div`
  position: absolute;
  top: 1vh;
  right: 1vw;
  max-height: 30vh;
  text-align: end;
  line-height: 1.4em;
`

const LogoutButton = styled.div`
  cursor: pointer;
`

const Title = styled.h1`
  margin: 0
`

export default function App() {
  const [loggingIn, setLoggingIn] = useState(true)
  const [loggedIn, setLoggedIn] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [user, setUser] = useState(null)
  const [wecs, setWecs] = useState(null)
  const effectRan = useRef(false)

  useEffect(() => {
    if (effectRan.current === false) {
      (async () => {
        setLoggingIn(true)
        try {
          const data = await login()
          setUser(data.name)
          setLoggedIn(true)
        }
        catch (e) {
          console.log('Login failed', e)
        }
        setLoggingIn(false)
      })()
    }
    return () => {
      effectRan.current = true
    }
  }, [])

  useEffect(() => {
    if (loggedIn) {
      (async function () {
        try {
          const wecs = await getWecs()
          wecs.sort((a, b) => -a.last_online?.localeCompare(b.last_online))
          console.log('Got wecs:', wecs)
          setWecs(wecs)
        } catch (e) {
          console.error("Failed to get Wecs", e)
        }
      })()
    }
    else {
      setWecs(null)
    }
  }, [loggedIn])

  function updateWec(updatedWec) {
    setWecs(wecs => wecs?.map(wec => wec.id === updatedWec.id ? { ...wec, ...updatedWec } : wec))
  }

  async function onGoogleLoginSuccess(response) {
    try {
      const data = await authenticate(response.credential)
      console.log('Authentication with Google token successful', data)
      setLoggedIn(true)
      setUser(data.name)
      setErrorMessage(null)
    }
    catch (e) {
      console.log('Authentication with Google token failed', e)
      setErrorMessage('Authentication failed')
    }
  }

  function onGoogleLoginError(error) {
    console.log("Google login error", error)
    setErrorMessage('Google login error')
  }

  async function onLogoutClicked() {
    await logout()
    setLoggedIn(false)
  }

  if (!loggedIn)
    return (
      <LoginContainer>
        <Logo src={'weco-logo-white.svg'} alt='logo' />
        <Title>Welcome</Title>
        <br /><br />
        {!loggingIn && <GoogleLogin onSuccess={onGoogleLoginSuccess} onError={onGoogleLoginError} auto_select />}
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </LoginContainer>
    )

  return (
    <div>
      <Logo src={'weco-logo-white.svg'} alt='logo' />
      <User>
        <div>{user}</div>
        <LogoutButton onClick={onLogoutClicked}>Logout</LogoutButton>
      </User>
      <Home wecs={wecs?.filter(wec => wec.hidden !== true)} updateWec={updateWec} />
    </div>
  )
}
